import { InvoiceRepository } from "../../repositories/InvoiceRepository";
import {
  InvoiceOperationResult,
  InvoiceDataEntity,
} from "../../entities/InvoiceEntity";

/**
 * Process Invoice JSON Use Case
 * Processes invoice JSON for GL classification
 */
export class ProcessInvoiceJsonUseCase {
  constructor(private repository: InvoiceRepository) {}

  async execute(
    invoiceData: InvoiceDataEntity
  ): Promise<InvoiceOperationResult> {
    // Validate invoice data
    // if (!invoiceData) {
    //   throw new Error("Invoice data is required");
    // }

    // if (!invoiceData.line_items || invoiceData.line_items.length === 0) {
    //   throw new Error("Invoice must have at least one line item");
    // }

    return await this.repository.processInvoiceJson(invoiceData);
  }
}
